import Swal from 'sweetalert2/dist/sweetalert2.js'
import { submitForm } from '@utils/request'
import customIcons from '@icons'

export const displayModal = (options) => {
	return Swal.fire({
		allowOutsideClick: false,
		closeButtonHtml: customIcons.cancel,
		...options
	})
}

export const displayAlert = (message, options) => {
	Swal.fire({
		...options,
		html: `<div class='swal2-message'>${message}</div>`,
		width: '360px',
		confirmButtonText: '확인',
		confirmButtonColor: '#55030b',
		icon: 'info'
	})
}

export const displayConfirm = async (message, confirmButtonText, icon = 'question', options) => {
	const result = await Swal.fire({
		...options,
		html: `<div class='swal2-message'>${message}</div>`,
		width: '360px',
		showCancelButton: true,
		confirmButtonText: confirmButtonText,
		cancelButtonText: '취소',
		confirmButtonColor: '#55030b',
		cancelButtonColor: '#f3f6f9',
		showClass: {
			backdrop: 'swal2-backdrop-show',
			popup: ''
		},
		hideClass: {
			backdrop: 'swal2-backdrop-hide',
			popup: ''
		},
		icon: icon
	})

	return result.isConfirmed
}

export const displayToast = (message, icon = 'success') => {
	Swal.mixin({
		toast: true,
		position: 'bottom-end',
		showConfirmButton: false,
		showCloseButton: true,
		timer: 5000
	}).fire({
		html: `
			<div class='swal2-toast-content'>
				${customIcons[icon]}
				<p class='swal2-toast-message'>${message}</p>
			</div>
		`,
	})
}


export const displayForm = async (title, html, formContext = {}, afterRender, afterSubmit) => {
	const validateForm = () => {
		for (const selector in formContext) {
			const { element, validator, validationMessage } = formContext[selector]
			if (validator && typeof validator === 'function') {
				const isValid = validator(element)
				if (!isValid) {
					displayValidationMessage(validationMessage)
					return false
				}
			}
		}

		return true
	}

	await Swal.fire({
		width: '420px',
		title: title,
		html: html,
		showCancelButton: true,
		showCloseButton: true,
		cancelButtonText: '취소',
		confirmButtonText: '저장',
		confirmButtonColor: '#55030b',
		cancelButtonColor: '#f3f6f9',
		allowOutsideClick: false,
		closeButtonHtml: customIcons.cancel,
		didRender: (renderedHtml) => {
			for (const selector in formContext) {
				const element = renderedHtml.querySelector(formContext[selector].selector)
				formContext[selector].element = element 
			}

			if (afterRender && typeof afterRender === 'function') afterRender(formContext)
		},
		preConfirm: async () => {
			if (validateForm()) {
				const response = await submitForm(formContext.form.element)

				if (afterSubmit && typeof afterSubmit === 'function') {
					afterSubmit(response)
				} else {
					if (response.isNewRecord) {
						const itemContainer = document.getElementById(response.itemContainerId)
						itemContainer.insertAdjacentHTML('afterbegin', response.itemHtml)
					} else {
						const item = document.getElementById(response.itemId)
						item.outerHTML = response.itemHtml
					}

					displayToast(`${title}이 완료되었습니다.`)
				}
			}
		}
	})
}

export const displayActionPopover = (ev) => { 
	ev.stopPropagation()

	const trigger = ev.target
	const actionPopover = trigger.closest('.popover-holder').querySelector('.action-popover')

	actionPopover.classList.remove('hidden')
	trigger.insertAdjacentElement('afterend', actionPopover)
}

export const resetActionPopover = (actionPopover) => {
	actionPopover.classList.add('hidden')

	actionPopover.closest('.popover-holder').insertAdjacentElement('afterbegin', actionPopover)
}

export const displayValidationMessage = (message) => Swal.showValidationMessage(message)

export const destroyModal = () => Swal.close()
